// export default () => ({
// })

export default () => ({
    outputdetails: [],
    outputdetailsSelectable: [],
    outputdetailsPaginatedData: null,
    outputdetail: null,
    isLoading: false,
    isCreating: false,
    createdData: null,
    isUpdating: false,
    updatedData: null,
    isDeleting: false,
    deletedData: null,
    selectedListData: null,
    isSelecting: false,
    isSuccessMultiStoreOutputdetails: false
})